
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getAddress, addAddress } from '@/api/address';
import { UserModule } from '@/store/modules/user';

import DialogAddAddress from '../../user/components/AddAddress.vue';

@Component({
  name: 'orderAddress',
  components: {
    DialogAddAddress
  }
})
export default class extends Vue {
  // 接受父组件的值
  @Prop({
    type: Boolean,
    default: true
  })autoGetAddress!:Boolean;

  @Prop({
    type: String,
    default: ''
  })addressListData!:String;

  @Prop({
    type: Boolean,
    default: false
  })addressVisible!:Boolean;

  private addressList: any = [];
  private radioSelected = ''

  created() {
    if (this.autoGetAddress) {
      this.getAddress();
    } else {
      this.addressList = JSON.parse(this.addressListData as string);
    }
  }

  getAddress() {
    const params = {
      user_id: UserModule.getUserId
    };
    getAddress(params)
      .then(res => {
        this.addressList = (res as any).data.list;
        for (let i = 0; i < this.addressList.length; i++) {
          let cont = this.addressList[i];
          cont.isActive = false;
          this.$set(this.addressList, cont, i);
        }
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  private close() {
    this.$emit('close', false);
  }

  private save() {
    // var address:any = {};
    // for (let i = 0; i < this.addressList.length; i++) {
    //   let cont = this.addressList[i];
    //   if (cont.isActive) {
    //     address = cont;
    //   }
    // }
    this.$emit('addressSelect', this.radioSelected);
    this.$emit('close', false);
  }

  // handle(val: any, index: number) {
  //   for (let i = 0; i < this.addressList.length; i++) {
  //     let cont = this.addressList[i];
  //     if (i !== index) {
  //       cont.isActive = false;
  //     }
  //   }
  //   val.isActive = true;
  //   this.$set(this.addressList, index, val);
  // }

  private dialogAddressVisible = false
  private formAddress: any = {}
  private addAddressClick() {
    this.formAddress = {
      address_type: 1
    };
    this.dialogAddressVisible = true;
  }
  private closeFormAddress(val: any) {
    this.dialogAddressVisible = val
  }
  private addAddress(val: any) {
    addAddress(val).then(res => {
      this.showSecussMsg((res as any).msg);
      this.dialogAddressVisible = false;
      this.getAddress();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
